<template>
  <div v-wechat-title="titleTop" class="allBack">
    <van-image v-show="loadImageFinish" width="100%" :src="imgUrl" @load="onImgLoadFinish" />
    <template v-if="!loadImageFinish">
      <img src="/img/third/ilabworldOceanDay/back2.jpg">
      <audio ref="audio" src="/img/third/ilab202104/click.mp3" />
      <div class="inputRect">
        <van-field v-model="name" placeholder="请输入昵称" input-align="center" maxlength="10" style="padding:0" />
      </div>
      <div class="buttonRect" @click="onBuild" />
    </template>
  </div>
</template>
<script>
import { Button, Field, Image } from 'vant'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { GetServiceUrlBase } from '@/utils/request'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Image.name]: Image
  },
  data() {
    return {
      titleTop: '为世界海洋日助力',
      name: '',
      loadImageFinish: false,
      imgUrl: undefined
    }
  },

  created() {

  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onBuild() {
      if (!this.name) {
        MyNotify('error', '请输入昵称')
        return
      }
      var url = GetServiceUrlBase() + '/userAPI/ThirdActivitie/GetiLab202104CardImage?name=' + this.name
      this.imgUrl = url
    },
    onImgLoadFinish() {
      this.loadImageFinish = true
    }
  }
}
</script>
<style scoped>
.allBack{
    position: relative;
    min-height: 100vh;
    background-color: #CCCCCC;
}
img{
    width: 100vw;
}
.inputRect{
    position: absolute;
    left: 24vw;
    right: 24vw;
    top: 104vw;
    height: 10vw;
}
.buttonRect{
    position: absolute;
    left: 30vw;
    right: 30vw;
    top: 113vw;
    height: 10vw;
}
</style>
